<!--

 -->

<template>
  <div class="gsl-hrm-login-branding">
    <div class="gsl-hrm-login-branding-logo">
      <img :src="imgSrc" alt="company-branding" />
    </div>
    <div v-if="hideOnBoarding" class="gsl-hrm-login-branding-wall">
      <img v-if="wall" :src="wall" alt="company-branding" />
      <oxd-text class="gsl-hrm-login-title" tag="h5">
        Welcome Aboard - Your Journey Starts Here
      </oxd-text>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LoginBranding',
  props: {
    imgSrc: {
      type: String,
      required: true,
    },
    wall: {
      type: String,
      required: false,
      default: null,
    },
    hideOnBoarding: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

<style src="./login-layout.scss" lang="scss" scoped></style>
